import React, { useEffect, useState, useCallback, useRef } from "react";
import API  from "../../../services";
import { toast } from "react-toastify";
import "./AccountStatement.scss";
// import Loader from "../../../assets/images/Strike_White_Logo_Transparent_GIF.gif";
import { useNavigate } from "react-router";
import Pagination from "../Pagination";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Loader } from "../../../constants/whitelabelEnv";
import { domain } from "../../../constants/Branding";
import { useTranslation } from "../../../hooks/useTranslation";
import { connect } from "react-redux";
import { RootState } from "../../../models/RootState";
interface CustomerSupportProps {
    userDetails?: any;
    dynamicTextColors?: any;
}



const AccountStatement: React.FC<CustomerSupportProps> = ({ userDetails, dynamicTextColors }) => {
    const { t } = useTranslation();
    const [page, setPage] = useState(0);
    const [loading, setLoading] = useState(false);
    const [tickets, setTickets] = useState<any>([]);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const navigate = useNavigate();
    const [count, setCount] = useState<any>(0);
    const [page1, setPage1] = useState(1);

    // Get dynamic text color classes from Redux instead of calling function
    const textColorClass = dynamicTextColors?.pageTextColorClass || '';
    const inputBoxTextColorClass = dynamicTextColors?.inputBoxTextColorClass || '';



    const dateFormat = (time: any) => {
        const matchStartTime = new Date(time);

        const formattedStartTime = matchStartTime.toLocaleString("en-GB", {
            day: "numeric",
            month: "numeric",
            year: "numeric",
            hour: "numeric",
            minute: "numeric",
            second: "numeric",
            hour12: false,
        });

        return formattedStartTime
    }


    const isFirstRender = useRef(true);


    const getAccountStatement = async () => {
        if (isFirstRender.current) {
            setLoading(true);
            isFirstRender.current = false;
        }

        let response;
        try {
            response = await API.post(`/users/account-statement`, {
                page: page1,
                pageSize: rowsPerPage,
            });
        } catch (e) {
            console.log(e);
            setLoading(false);
            return;
        }

        if (response.data.status !== "RS_OK") {
            navigate("/home");
        }

        if (response && response.data?.ledgers) {
            setTickets(response?.data?.ledgers);
            if (page1 === 0 || page1 === 1) {
                setCount(response?.data?.total);
            }
        }
        setLoading(false);
    };


    useEffect(() => {
        getAccountStatement();
    }, [])




    const handleChangePage = (
        event: React.MouseEvent<HTMLButtonElement> | null,
        newPage: number,
    ) => {
        setPage(newPage);
        getAccountStatement();
    };

    const handleBackClick = () => {
        navigate(-1);
    };




    return (
        <>
            <div className={`flex flex-col px-3 mt-4 w-full pb-[7rem] py-[4rem] AccStatement ${textColorClass}`}>
                {
                    loading ? (
                        <div className="home-loading">
                            <img src={Loader(domain)} style={{ height: '10rem' }} />
                        </div>
                    ) : (
                        <>
                           <header className={`flex gap-3 items-center self-start text-base font-medium text-center mb-[0.5rem] ${textColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}>
                           <div>
                                <div className="bg-inputbox-color flex p-1 mr-[0.25rem] rounded"
                                    onClick={() => handleBackClick()}
                                >
                                    <ArrowBackIcon
                                        className={`aspect-square w-[18px] ${inputBoxTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}
                                        style={{ width: '20px', height: '20px' }}
                                    />
                                </div>
                            </div>
                                <h2 className="self-stretch my-auto">{t("transactions.accountStatement")}</h2>
                            </header>
                            <div className={`flex justify-center mb-2 ${textColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}>
                                <div className="mr-16">
                                    <span className="inline-block w-2 h-2 bg-blue-500 rounded-full mr-2"></span>{t("common.points")}
                                </div>
                                <div className="mr-16">
                                    <span className="inline-block w-2 h-2 bg-yellow-500 rounded-full mr-2"></span>{t("common.playChips")}
                                </div>
                                <div>
                                    <span className="inline-block w-2 h-2 bg-green-500 rounded-full mr-2"></span>{t("common.reward")}
                                </div>
                            </div>
                            <div className="overflow-x-auto">
                                <table className="min-w-full border-collapse user-table border-x mt-1">
                                    <thead>
                                        <tr>
                                            <th className={`px-4 py-2 text-left border-b border-t ${textColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}>{t("bets.date")}</th>
                                            <th className={`px-4 py-2 text-left border-b border-t ${textColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}>{t("transactions.type")}</th>
                                            <th className={`px-4 py-2 text-left border-b border-t ${textColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}>{t("common.amount")}</th>
                                            <th className={`px-4 py-2 text-left border-b border-t ${textColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}> Closing Balance</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {tickets.map((row: any, index: number) => (
                                            <tr key={index} className="border-b"
                                            >
                                                <td className={`px-4 py-2  ${textColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}>
                                                    {dateFormat(row?.TransactionTime)}
                                                </td>
                                                <td className={`px-4 py-2 text-left ${textColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}>
                                                    {row?.TransactionType
                                                        ?.split('_')
                                                        .map((word: any) => word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase())
                                                        .join(' ')}
                                                </td>
                                                <td
                                                    className={`px-4 py-2 text-left ${row?.Points > 0 || row?.PlayChips > 0 || row?.Reward > 0
                                                        ? 'text-green-500'
                                                        : row?.Points < 0 || row?.PlayChips < 0 || row?.Reward < 0
                                                            ? 'text-red-500'
                                                            : textColorClass === 'dark-text' ? 'text-black' : 'text-white'
                                                        }`}
                                                >
                                                    {row?.Points !== 0 ? (
                                                        <div className="flex items-center">
                                                            <span className="inline-block w-2 h-2 bg-blue-500 rounded-full mr-2"></span>
                                                            {row?.Points % 1 === 0 ? row?.Points : row?.Points.toFixed(2)}
                                                        </div>
                                                    ) : row?.PlayChips !== 0 ? (
                                                        <div className="flex items-center">
                                                            <span className="inline-block w-2 h-2 bg-yellow-500 rounded-full mr-2"></span>
                                                            {row?.PlayChips % 1 === 0
                                                                ? row?.PlayChips
                                                                : row?.PlayChips.toFixed(2)}
                                                        </div>
                                                    ) : row?.Reward !== 0 ? (
                                                        <div className="flex items-center">
                                                            <span className="inline-block w-2 h-2 bg-green-500 rounded-full mr-2"></span>
                                                            {row?.Reward % 1 === 0
                                                                ? row?.Reward
                                                                : row?.Reward.toFixed(2)}
                                                        </div>
                                                    ) : (
                                                        0
                                                    )}
                                                </td>
                                                <td className={`px-4 py-2 text-left ${textColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}>
                                                    {row?.ClosingBalance % 1 === 0 ? row?.ClosingBalance : row?.ClosingBalance.toFixed(2)}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                            </div>
                            <Pagination currentPage={page1} setCurrentPage={setPage1} setRowsPerPage={setRowsPerPage} rowsPerPage={rowsPerPage} eventsCount={count} callBackFunc={getAccountStatement} />
                        </>
                    )
                }
            </div>
        </>
    );
};



const mapStateToProps = (state: RootState) => {
    return {
        userDetails: state.userDetails?.userDetails,
        dynamicTextColors: state.userDetails?.dynamicTextColors,
    };
};

export default connect(mapStateToProps)(AccountStatement);
